export default function isEmptyObjectUtil (obj) {
  if (!obj) {
    return true
  }

  return !Object.keys(obj || {}).length
}
